import { render, staticRenderFns } from "./Broker.vue?vue&type=template&id=be457694&scoped=true&"
import script from "./Broker.vue?vue&type=script&lang=js&"
export * from "./Broker.vue?vue&type=script&lang=js&"
import style0 from "./Broker.vue?vue&type=style&index=0&id=be457694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be457694",
  null
  
)

export default component.exports